import { IDynamicField, IListOrder, IDynamicFieldUpdatePayload, IDynamicFieldDetail, IDynamicFieldCreatePayload } from './../models/dynamic-fields';
import { IResponse } from './../models/util';
import axios, { AxiosResponse } from 'axios';
import { authFetch } from '.';
import { ILookupType } from '../models/employee';

const baseUrl = '/api/Admin/DynamicFields';

export const DynamicFieldAPI = {
  async getAll(filters?: {
    page?: number;
    perPage?: number;
    sortBy?: string;
    sortDirection?: string;
    teamId: number | string;
    entityTypeId: number | string;
  }): Promise<IResponse<IDynamicField[]>> {
    try {
      const response: AxiosResponse<IResponse<IDynamicField[]>> = await authFetch.get(`${baseUrl}/list`, filters);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async getDynamicField(id: number | string): Promise<IDynamicFieldDetail> {
    try {
      const response: AxiosResponse<IDynamicFieldDetail> = await authFetch.get(`${baseUrl}/${id}`);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },


  async createDynamicField(payload: IDynamicFieldCreatePayload): Promise<void> {
    try {
      const response: AxiosResponse<void> = await authFetch.post(`${baseUrl}`, payload);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async updateDynamicField(payload: IDynamicFieldUpdatePayload): Promise<void> {
    try {
      const response: AxiosResponse<void> = await authFetch.put(`${baseUrl}`, payload);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async deleteDynamicField(id: number | string): Promise<void> {
    try {
      const response: AxiosResponse<void> = await authFetch.delete(`${baseUrl}/${id}`);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async updateListOrder(listOrderObject: IListOrder): Promise<void> {
    try {
      const response: AxiosResponse<void> = await authFetch.put(`${baseUrl}/list-order`, listOrderObject);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async fetchEntityTypes(): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/lookup/entity-types`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async fetchInputTypes(): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/lookup/input-data-types`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async fetchTeam(employeeId: string | number): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/lookup/teams/${employeeId}`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async fetchEntityCount(dynamicFieldId: string | number): Promise<number> {
    try {
      const response: AxiosResponse<number> = await authFetch.get(`${baseUrl}/entity-count/${dynamicFieldId}`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
};
